import React from 'react';
import Hub from './pages/Hub';
import Resume from './pages/Resume';

function App() {
  return window.location.pathname === '/resume' ? <Resume /> : <Hub />;
}

export default App;
